import React from 'react';
import { Button, SIZE as BUTTON_SIZE } from 'baseui/button';
import { Pagination } from 'baseui/pagination';
import type { Value } from 'baseui/select';
import { Select, TYPE } from 'baseui/select';
import { Spinner } from 'baseui/spinner';
import { DIVIDER, SIZE as TABLE_SIZE, Table } from 'baseui/table-semantic';
import { toaster } from 'baseui/toast';
import { PROJECT_VIEW_TABLE_COLUMNS } from '../../../consts/project';
import { useGetProjects } from '../../../hooks/use-get-projects';
import { useGetUserGroupsMinified } from '../../../hooks/use-get-user-groups-minified';
import { useUpdateProject } from '../../../hooks/use-update-project';
import type { Project as ProjectT } from '../../../types/project';
import ErrorComponent from '../error';
import { TableInnerContainer, TableOuterContainer } from '../TableContainer';
import ProjectManagementForm from './project-creation-form';
import ProjectDetailsModal from './project-details-modal';
const Project = () => {
  const [project, setProject] = React.useState<ProjectT | null>(null);
  const [pageNumber, setPageNumber] = React.useState<number>(1);
  const [showViewProjectModal, setViewProjectShowModal] = React.useState(false);
  const [showEditProjectPage, setEditProjectPage] = React.useState(false);
  const {
    data: projectData,
    isLoading: getProjectsLoading,
    error: getProjectError
  } = useGetProjects(pageNumber, 100);
  const {
    data: userGroups,
    error: getUserGroupsError,
    isLoading: getUserGroupsLoading
  } = useGetUserGroupsMinified();
  const {
    isPending: isUpdateProjectPending,
    updateProject
  } = useUpdateProject();
  const updateProjectHandler = (project: ProjectT, value: Value) => {
    if (!value || value.length === 0 ||
    // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
    value[0].id === undefined ||
    // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
    value[0].id === project.userGroupId || isUpdateProjectPending) {
      return;
    }
    updateProject({
      // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
      groupId: +value[0].id,
      projectId: project.id
    }, {
      onSuccess: () => {
        toaster.positive('Updated project successfully', {
          key: 'updateProjectSuccess'
        });
      },
      onError: error => {
        toaster.negative(`Failed creating or updating project: ${error.message}`, {
          key: 'updateProjectError'
        });
      }
    });
  };
  if (getProjectError || getUserGroupsError) {
    return <ErrorComponent message={getProjectError?.message || getUserGroupsError?.message || 'Something went wrong'} />;
  }
  if (getUserGroupsLoading || getProjectsLoading) {
    return <Spinner />;
  }
  const {
    projects,
    totalPages
  } = projectData!;
  const {
    groups
  } = userGroups!;
  if (showEditProjectPage) {
    return <ProjectManagementForm closeForm={() => {
      setEditProjectPage(false);
    }} groups={groups} />;
  }
  return <TableOuterContainer>
      {showViewProjectModal && project && <ProjectDetailsModal project={project} setShowModal={setViewProjectShowModal} showModal={showViewProjectModal} />}
      <div>
        <Button size={BUTTON_SIZE.compact} onClick={() => {
        setEditProjectPage(true);
        setProject(null);
      }}>
          Create Project
        </Button>
      </div>
      <TableInnerContainer>
        <Table size={TABLE_SIZE.spacious} divider={DIVIDER.grid} columns={PROJECT_VIEW_TABLE_COLUMNS} data={projects.map(project => {
        const userGroup = groups.find(group => group.id === project.userGroupId);
        return [project.id, project.name, project.majorStates.join(', '), `MetaReview: ${project.nextStateOnMetaReviewReject || 'N/A'}`, <Select key={`select-${project.id}`} options={groups} labelKey="name" valueKey="id" placeholder="Choose user group" maxDropdownHeight="300px" type={TYPE.search} onChange={({
          value
        }) => {
          updateProjectHandler(project, value);
        }} value={userGroup ? [userGroup] : []} />, <Button key={project.id} size={BUTTON_SIZE.compact} onClick={() => {
          setProject(project);
          setViewProjectShowModal(true);
        }}>
                View
              </Button>];
      })} />
      </TableInnerContainer>
      <Pagination numPages={totalPages} currentPage={pageNumber} onPageChange={({
      nextPage
    }) => {
      setPageNumber(Math.min(Math.max(nextPage, 1), totalPages));
    }} />
    </TableOuterContainer>;
};
export default Project;